import React, { useState, useEffect } from 'react';
// ⬇️ Sesuaikan path context sesuai lokasi file kamu
import { useDarkMode } from '../../darkmode/DarkModeContext';

const HeroSection = () => {
  const { isDarkMode } = useDarkMode();

  const [promoTimeLeft, setPromoTimeLeft] = useState({
    days: 2,
    hours: 8,
    minutes: 33,
    seconds: 45
  });

  // Promo countdown timer
  useEffect(() => {
    const timer = setInterval(() => {
      setPromoTimeLeft(prev => {
        if (prev.seconds > 0) {
          return { ...prev, seconds: prev.seconds - 1 };
        } else if (prev.minutes > 0) {
          return { ...prev, minutes: prev.minutes - 1, seconds: 59 };
        } else if (prev.hours > 0) {
          return { ...prev, hours: prev.hours - 1, minutes: 59, seconds: 59 };
        } else if (prev.days > 0) {
          return { ...prev, days: prev.days - 1, hours: 23, minutes: 59, seconds: 59 };
        }
        return prev;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const handleScrollToPackages = () => {
    const packagesElement = document.getElementById('packages');
    if (packagesElement) {
      packagesElement.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative overflow-hidden min-h-screen flex items-center">
      {/* Background overlay – selaras dengan Services (gambar di parent + overlay di sini) */}
      <div className="absolute inset-0 z-0">
        {/* Overlay utama: hijau #1E9B4C */}
        <div
          className={`absolute inset-0 ${
            isDarkMode
              ? 'bg-gradient-to-r from-black/80 via-[#1E9B4C]/25 to-black/80'
              : 'bg-gradient-to-r from-white/70 via-[#1E9B4C]/20 to-white/70'
          }`}
        />
        {/* Lapisan tambahan tipis untuk kontras teks */}
        <div className={`absolute inset-0 ${isDarkMode ? 'bg-black/40' : 'bg-white/10'}`} />
      </div>

      {/* Content */}
      <div className="relative z-20 max-w-7xl mx-auto px-4 text-center w-full">
        <div className="mb-8">
          <h1
            className={`text-5xl md:text-7xl font-bold mb-6 leading-tight ${
              isDarkMode ? 'text-green-50' : 'text-gray-900'
            }`}
          >
            Internet{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#1E9B4C] to-emerald-400">
              Super Cepat
            </span>
          </h1>

          <p
            className={`text-xl md:text-2xl mb-8 max-w-4xl mx-auto leading-relaxed transition-colors ${
              isDarkMode ? 'text-gray-300' : 'text-gray-700'
            }`}
          >
            Rasakan pengalaman internet fiber optic ultra-cepat untuk rumah dan bisnis. Streaming, gaming, dan bekerja tanpa batas dengan koneksi stabil 24/7.
          </p>
        </div>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-16">
          <button
            onClick={handleScrollToPackages}
            className={`px-8 py-4 rounded-full font-bold text-lg transition-all transform hover:scale-105 shadow-2xl
              ${isDarkMode
                ? 'bg-[#1E9B4C] text-green-50 hover:bg-emerald-600'
                : 'bg-[#1E9B4C] text-white hover:bg-green-700'}`}
          >
            Pilih Paket Internet
          </button>
        </div>

        {/* Key Features Pills */}
        <div className="flex flex-wrap justify-center gap-4">
          {[
            { icon: '🚀', text: 'Hingga 1 Gbps' },
            { icon: '∞', text: 'Unlimited Quota' },
            { icon: '📶', text: 'WiFi 6/6E' },
            { icon: '🔧', text: 'Instalasi Gratis' }
          ].map((feature, index) => (
            <div
              key={index}
              className={`px-4 py-2 rounded-full backdrop-blur-sm border transition-colors
                ${isDarkMode
                  ? 'bg-white/10 border-white/20 text-green-50'
                  : 'bg-white/40 border-white/60 text-gray-800'}`}
            >
              <span className="text-lg mr-2">{feature.icon}</span>
              <span className="text-sm font-semibold">{feature.text}</span>
            </div>
          ))}
        </div>

        {/* (Opsional) Countdown Promo – contoh tampilan kecil */}
        <div className="mt-10 flex items-center justify-center gap-3">
          {[
            { label: 'Hari', value: promoTimeLeft.days },
            { label: 'Jam', value: promoTimeLeft.hours },
            { label: 'Menit', value: promoTimeLeft.minutes },
            { label: 'Detik', value: promoTimeLeft.seconds }
          ].map((item) => (
            <div
              key={item.label}
              className={`countdown-item px-4 py-2 rounded-xl text-center min-w-[70px] transition-colors
                ${isDarkMode ? 'bg-white/10 border border-white/20 text-green-50' : 'bg-white/60 border border-white/70 text-gray-900'}`}
            >
              <div className="text-2xl font-bold">{item.value}</div>
              <div className={`text-xs mt-1 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>{item.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
